<template>
  <Layout>
    <GoBack class="mb-5" text="shottracker news" link="Media" />

    <LoadingSpinner v-if="loading.display" :message="loading.message" />

    <p class="text-lg mb-5">Upload new article</p>

    <ArticleForm :form="form" @handleSubmit="handleSubmit" />
  </Layout>
</template>

<script>
import Layout from "../../Layout.vue";
import GoBack from "../../GoBack.vue";
import LoadingSpinner from "../../LoadingSpinner.vue";
import ArticleForm from "./ArticleForm.vue";
import { mapGetters, mapActions } from "vuex";
import { uuid } from "vue-uuid";
import loader from "../../../mixins/loader";

export default {
  name: "UploadNewArticle",
  mixins: [loader],

  components: {
    Layout,
    GoBack,
    LoadingSpinner,
    ArticleForm,
  },

  data() {
    return {
      form: {
        link: "",
        header: "",
        body: "",
        author: "shottracker",
        image: null,
        subheader: "",
        homeFeatured: false,
      },
    };
  },

  computed: {
    ...mapGetters(["articlesID"]),
  },

  methods: {
    ...mapActions(["addArticleToS3"]),

    async handleSubmit() {
      let fileJSON = {};
      fileJSON = Object.assign(fileJSON, this.form);

      const { S3Path, directoryKey } = this.articlesID;

      const uniqueID = uuid.v4();
      const identifier = `${S3Path}${uniqueID}/`;

      const newIndex = {
        header: fileJSON.header,
        author: fileJSON.author,
        homeFeatured: fileJSON.homeFeatured,
        subheader: fileJSON.subheader,
        id: identifier,
      };

      window.scroll({
        top: 0,
        behavior: "smooth",
      });

      const article = { fileJSON, identifier, newIndex, directoryKey };
      await this.load(this.addArticleToS3(article), "Uploading article");

      this.$router.push({
        name: "Media",
      });
    },
  },
};
</script>
